export default __webpack_public_path__ + "static/media/a037-5.4a65b6cb.svg";